<template>
  <section class="panel fading">
    <h1>Create a new memorial - Step 1 of 3</h1>
    <div class="text" v-html="text.new_step_1" v-if="text"></div>
    <div :class="style.type ? 'selected' : ''" class="options">
      <a
        :class="style.type == 'catalogue' ? 'selected' : ''"
        @click.prevent="
          scrollFix('#anchor')
          style.type = 'catalogue'
        "
        href
      >
        <span>Choose from our catalogue</span>
      </a>
      <a
        :class="style.type == 'shape' ? 'selected' : ''"
        @click.prevent="
          scrollFix('#anchor')
          style.type = 'shape'
        "
        href
      >
        <span>Choose a basic shape, colour &amp; size</span>
      </a>
      <a
        :class="style.type == 'photo' ? 'selected' : ''"
        @click.prevent="
          scrollFix('#anchor')
          style.type = 'photo'
        "
        href
      >
        <span>Upload a photograph</span>
      </a>
    </div>
    <div id="anchor"></div>
    <div class="nofade details" v-if="style.type == 'catalogue'">
      <p>
        Ok, please
        <a href="/catalogue/Odlings_Brochure_2017_PDF.pdf" target="_blank" rel="noreferrer">download our catalogue</a>
        then make a selection below.
      </p>
      <p>My chosen style is:</p>
      <input class="type" placeholder="Enter product code / name" type="text" v-model="style.product" />
    </div>
    <div class="nofade details" v-if="style.type == 'shape'">
      <p>Ok, please choose a shape:</p>
      <div :class="style.shape.value ? 'selected' : ''" class="shapes">
        <a
          :class="[style.shape.value == shp.value ? 'selected' : '']"
          :key="shp.name"
          @click.prevent="
            style.shape = shp
            style.size = '_'
          "
          href
          v-for="shp in shapes"
        >
          <span>
            <img :alt="shp.name" :src="'/images/shapes/' + shp.image" />
            <span>{{ shp.name }}</span>
          </span>
        </a>
      </div>
      <template v-if="style.shape.name">
        <p>a colour:</p>
        <div :class="style.colour.name ? 'selected' : '_'" class="colours" v-if="colours">
          <a
            :class="[col.contrast ? 'contrast' : '', style.colour.name == col.name ? 'selected' : '']"
            :key="col._id"
            :style="'background-image:url(' + col.image + ')'"
            @click.prevent="style.colour.name == col.name ? (style.colour = {}) : (style.colour = col)"
            href
            v-for="col in colours"
          >
            <span>{{ col.name }}</span>
          </a>
        </div>
      </template>
      <template v-if="style.colour.name">
        <p>and a size:</p>
        <div class="sizes">
          <select class="cbo-size" v-model="style.size">
            <option value="_">make a selection...</option>
            <template v-for="size in style.shape.sizes">
              <option
                :key="size"
                :value="size"
                v-if="
                  style.colour.name == 'Black' ||
                    (style.colour.name !== 'Black' && size.indexOf('2\'0 x 1\'6 x 3') === -1)
                "
                >{{ size }}</option
              >
            </template>
          </select>
        </div>
      </template>
    </div>
    <div class="nofade details" v-if="style.type == 'photo'">
      <p>No problem, please upload your photograph below:</p>
      <!-- <input class="upload" type="file" />
      <div class="upload">Click here or drag and drop your photo</div>-->
      <img :src="current_image" alt v-if="current_image" width="200" />

      <vue-dropzone
        :options="dropzoneOptions"
        @vdropzone-mounted="dzMounted"
        @vdropzone-success="success"
        class="upload"
        id="dropzone"
        ref="dropzone"
      ></vue-dropzone>
    </div>

    <div class="actions">
      <button @click="$router.push('started')" class="button back">Back</button>
      <button
        @click="nav"
        class="button"
        v-if="
          (style.type == 'catalogue' && style.product) ||
            (style.type == 'shape' && style.shape.value && style.colour.name && style.size != '_') ||
            (style.type == 'photo' && style.photo)
        "
      >
        Continue
        <pulse></pulse>
      </button>
    </div>
  </section>
</template>

<script>
import Pulse from "@/components/Pulse.vue"
import vue2Dropzone from "vue2-dropzone"
import "vue2-dropzone/dist/vue2Dropzone.min.css"
export default {
  data() {
    return {
      style: {},
      current_image: "",

      dropzoneOptions: {
        url: "/.netlify/functions/image",
        maxFilesize: 2,
        headers: {},
        acceptedFiles: "image/*",
        dictDefaultMessage: "Click here or drag and drop your photo",
        resizeWidth: 900
      }
    }
  },
  created() {
    this.style = this.$store.state.style
    if (this.$route.query.ref == "web") {
      this.style.type = "shape"
    }
  },
  computed: {
    text() {
      return this.$store.state.text
    },
    colours() {
      return this.$store.state.colours
    },
    shapes() {
      return this.$store.state.shapes
    }
  },
  components: {
    Pulse,
    vueDropzone: vue2Dropzone
  },
  methods: {
    scrollFix: function(hash) {
      document.getElementById(hash.replace("#", "")).scrollIntoView(true, { behavior: "smooth" })
    },
    nav: function() {
      if (this.style.type == "catalogue" || this.style.type == "photo")
        this.style.shape = this.shapes.filter(s => s.value == "CrematoriumTablet")[0]
      this.$store.commit("setStyle", this.style)

      this.$router.push({ path: "designer" })
    },
    success: function(file) {
      var dz = this.$refs.dropzone.dropzone
      if (dz.files[1] != null) dz.removeFile(dz.files[0])

      this.$set(this.style, "photo", file.dataURL)
      this.$set(this.style, "_photoSize", file.size)
      this.$set(this.style, "_photoType", file.type)
      this.$set(this.style, "_photoName", file.name)
      this.current_image = ""
    },
    dzMounted: function() {
      if (this.style.photo) this.current_image = this.style.photo
    }
  }
}
</script>

<style scoped>
.panel {
  text-align: center;
  padding-bottom: 15rem;
}
.actions {
  margin-top: 3rem;
}
.colours {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 1rem;
  padding-top: 3rem;
  padding-bottom: 3rem;
  max-width: 80rem;
  margin: auto;
}
.shapes {
  display: grid;
  grid-gap: 5rem;
  padding-top: 3rem;
  max-width: 80rem;
  margin: auto;
  grid-template-columns: repeat(3, 1fr);
  padding-bottom: 3rem;
}
.colours a,
.shapes a {
  min-height: 10rem;
  border: 1px solid #e7e7e7;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  transition: all 0.3s;
}
.shapes img {
  margin-top: 2rem;
}
.colours a span,
.shapes a span {
  display: block;
  width: 100%;
}
.shapes a span {
  line-height: 1.2;
  padding: 0.5rem 0;
}
.colours.selected a,
.shapes.selected a {
  opacity: 0.1;
}
.colours.selected a:hover,
.colours a.selected,
.shapes.selected a:hover,
.shapes a.selected {
  opacity: 1;
}
.hide {
  display: none !important;
}
.colours a {
  color: white;
  line-height: 1.2;
  font-size: 1.2rem;
}
.colours a.contrast {
  color: #333;
}
.options {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 5rem;
  margin-top: 5rem;
}
.options.selected a {
  opacity: 0.5;
  min-height: 10rem;
}
.options a {
  display: flex;
  align-items: center;
  min-height: 20rem;
  text-align: center;
  border: 1px solid #e7e7e7;
  border-radius: 1rem;
  transition: all 0.3s;
  font-size: 2.5rem;
}
.options a:hover {
  opacity: 1;
  background: #fafafa;
}
.options a.selected {
  opacity: 1;
  background: #e3e8e8;
  border: 1px solid #e3e8e8;
}
.options a span {
  display: block;
  width: 100%;
  padding: 5rem;
  line-height: 1.2;
}
.details {
  padding-top: 5rem;
}
.select,
.type {
  margin-top: 3rem;
  padding: 1rem 1.5rem;
  border-radius: 0.5rem;
  border: 1px solid #e7e7e7;
  width: 30rem;
}
.upload {
  border: 0.5rem dashed #f5f5f5;
  padding: 3rem 5rem;
  max-width: 50rem;
  margin: auto;
  margin-top: 3rem;
  border-radius: 1rem;
  color: #ccc;
  cursor: pointer;
}

.cbo-size {
  padding: 0.5rem 1rem;
}

.sizes {
  margin-bottom: 4rem;
}

@media screen and (max-width: 750px) {
  .options {
    grid-template-columns: 1fr;
    grid-gap: 3rem;
  }
  .options a {
    min-height: 5rem;
  }
  .colours {
    grid-gap: 2rem;
  }

  .shapes {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media screen and (max-width: 440px) {
  .colours,
  .shapes {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 2rem;
  }
}
</style>
